<template>
  <img :src="imgSrc" />
</template>

<script>
import { assetApi } from 'api'
export default {
  data () {
    return {
      imgSrc: ''
    }
  },
  mounted () {
    this.populateUrl()
  },
  methods: {
    populateUrl () {
      this.imgSrc = assetApi.getPreviewUrl(this.page.assetUrlPath, 'thumb')
    }
  },
  props: {
    page: {
      type: Object
    }
  },
  watch: {
    page: {
      deep: true,
      handler (value) {
        this.populateUrl()
      }
    }
  }
}
</script>

<style>

</style>
